import React, { useRef } from "react";
import { useSelector } from "react-redux";
import _ from "lodash";

import cx from "classnames";
import Slider from "react-slick";
import { IKImage } from "imagekitio-react";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import styles from "./wallofframe.module.scss";

const icData = [
  {
    "name": "Making Transit Trains Greener",
    "url": "https://experiences.cleverstory.io/wabtec/making-transit-trains-greener",
    "desktopIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/wabtec.png",
    "mobileIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/wabtecMob.png",
    "type": "INTERACTIVE_CONTENT",
    "category": "Product Presentation",
    "industry": "Engineering",
    "owner": "Wabtec",
    "ownerIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/wabtecIcon.png"
  },
  {
    "name": "Guide for Executing Projects",
    "url": "https://experiences.cleverstory.io/monday-com/managers-guide",
    "desktopIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/monday.png",
    "mobileIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/mondayMob.png",
    "type": "INTERACTIVE_CONTENT",
    "category": "Guidebook",
    "industry": "Marketing",
    "owner": "Monday",
    "ownerIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/mondayIcon.png"
  },
  {
    "name": "Premium Craftsmanship of Boats",
    "url": "https://experiences.cleverstory.io/haineshunter-x3hp9x/welcome",
    "desktopIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/haineshunter.png",
    "mobileIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/haineshunterMob.png",
    "type": "INTERACTIVE_CONTENT",
    "category": "Product Presentation",
    "industry": "Engineering",
    "owner": "Haineshunter",
    "ownerIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/haineshunterIcon.png"
  },
  {
    "name": "Villa Rental",
    "url": "https://experiences.cleverstory.io/villa-rental/villa-rental",
    "desktopIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/oetkercollection.png",
    "mobileIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/oetkercollectionMobpng.png",
    "type": "INTERACTIVE_CONTENT",
    "category": "Website",
    "industry": "Hospitality",
    "owner": "Oetkercollection",
    "ownerIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/oetkercollectionIcon.png"
  },
  {
    "name": "Comic Con",
    "url": "https://experiences.cleverstory.io/comic-con/comic-con-themes-report-2024",
    "desktopIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/impact.png",
    "mobileIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/impactMob.png",
    "type": "INTERACTIVE_CONTENT",
    "category": "Events",
    "industry": "Marketing",
    "owner": "Impact",
    "ownerIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/impactIcon.png"
  },
  {
    "name": "Future of Industry Solution",
    "url": "https://experiences.cleverstory.io/happiestminds",
    "desktopIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/happiestMinds.png",
    "mobileIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/happiestMindsMob.png",
    "type": "INTERACTIVE_CONTENT",
    "category": "Company Presentation",
    "industry": "Healthcare",
    "owner": "Happiest Minds",
    "ownerIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/happiestMindsIcon.png"
  },
  {
    "name": "Innovate or Perish",
    "url": "https://experiences.cleverstory.io/infovision/innovate-or-perish",
    "desktopIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/infovision.png",
    "mobileIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/infovisionMob.png",
    "type": "INTERACTIVE_CONTENT",
    "category": "Company Presentation",
    "industry": "Healthcare",
    "owner": "Infovision",
    "ownerIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/infovisionIcon.png"
  },
  {
    "name": "Trade Connect",
    "url": "https://experiences.cleverstory.io/pirum/tradeconnect",
    "desktopIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/pirum.png",
    "mobileIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/pirumMob.png",
    "type": "INTERACTIVE_CONTENT",
    "category": "Product Brochure",
    "industry": "Financial Services",
    "owner": "Pirum",
    "ownerIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/pirumIcon.png"
  },
  {
    "name": "Firerobot",
    "url": "https://experiences.cleverstory.io/firerobot",
    "desktopIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/fibersmart.png",
    "mobileIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/fibersmartMob.png",
    "type": "INTERACTIVE_CONTENT",
    "category": "Product Presentation",
    "industry": "Engineering",
    "owner": "Fibersmart",
    "ownerIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/fibersmartIcon.png"
  },
  {
    "name": "Monthly Summary",
    "url": "https://experiences.cleverstory.io/lucosky/june-micro-cap-monthly",
    "desktopIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/lucosky.png",
    "mobileIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/lucoskyMob.png",
    "type": "INTERACTIVE_CONTENT",
    "category": "Blog",
    "industry": "Public Service",
    "owner": "Lucosky",
    "ownerIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/lucoskyIcon.png"
  }
]
const lpData = [
  {
    "name": "Future of AI",
    "url": "https://experiences.cleverstory.io/hp",
    "desktopIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/hp.png",
    "mobileIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/hpMob.png",
    "type": "LANDING_PAGE",
    "category": "Product Presentation",
    "industry": "IT",
    "owner": "HP",
    "ownerIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/hpIcon.png"
  },
  {
    "name": "Cutting Edge Tech",
    "url": "https://experiences.cleverstory.io/page-1-myjuao",
    "desktopIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/quantumBotics.png",
    "mobileIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/quantumBoticsMob.png",
    "type": "LANDING_PAGE",
    "category": "Product Presentation",
    "industry": "Engineering",
    "owner": "Quantum Botics",
    "ownerIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/quantumBoticsIcon.png"
  },
  {
    "name": "Aligner System",
    "url": "https://experiences.cleverstory.io/orthofx",
    "desktopIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/orthofx.png",
    "mobileIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/orthofxMob.png",
    "type": "LANDING_PAGE",
    "category": "Product Presentation",
    "industry": "Healthcare",
    "owner": "Orthofx",
    "ownerIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/orthofxIcon-1.png"
  },
  {
    "name": "University",
    "url": "https://experiences.cleverstory.io/parul-university",
    "desktopIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/parulUniversity.png",
    "mobileIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/parulUniversityMob.png",
    "type": "LANDING_PAGE",
    "category": "Company Presentation",
    "industry": "Education",
    "owner": "Parul University",
    "ownerIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/parulUniversityIcon.png"
  },
  {
    "name": "Innovation in Trains",
    "url": "https://experiences.cleverstory.io/wabtec-landingpage",
    "desktopIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/wabtec2.png",
    "mobileIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/wabtec2Mob.png",
    "type": "LANDING_PAGE",
    "category": "Product Presentation",
    "industry": "Engineering",
    "owner": "Wabtec",
    "ownerIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/wabtecIcon.png"
  },
  {
    "name": "ERP for Government Contractors",
    "url": "https://experiences.cleverstory.io/deltek",
    "desktopIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/deltek.png",
    "mobileIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/deltekMob.png",
    "type": "LANDING_PAGE",
    "category": "Website",
    "industry": "Public Service",
    "owner": "Deltek",
    "ownerIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/deltekIcon.png"
  },
  {
    "name": "AI and Simulation",
    "url": "https://experiences.cleverstory.io/altair",
    "desktopIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/atlair.png",
    "mobileIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/atlairMob.png",
    "type": "LANDING_PAGE",
    "category": "Product Presentation",
    "industry": "IT",
    "owner": "Atlair",
    "ownerIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/atlairIcon.png"
  },
  {
    "name": "Modern Analytics",
    "url": "https://experiences.cleverstory.io/cloudflux",
    "desktopIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/cloudFlux.png",
    "mobileIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/cloudFluxMob.png",
    "type": "LANDING_PAGE",
    "category": "Company Presentation",
    "industry": "Marketing",
    "owner": "CloudFlux",
    "ownerIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/cloudFluxIcon.png"
  },
  {
    "name": "Strategic Communication and Social Media",
    "url": "https://experiences.cleverstory.io/gitex-introduction",
    "desktopIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/tarjama.png",
    "mobileIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/tarjamaMob.png",
    "type": "LANDING_PAGE",
    "category": "Company Presentation",
    "industry": "Marketing",
    "owner": "Tarjama",
    "ownerIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/tarjamaIcon.png"
  },
  {
    "name": "Atlas Intelligence",
    "url": "https://experiences.cleverstory.io/zs",
    "desktopIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/zs.png",
    "mobileIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/zsMob.png",
    "type": "LANDING_PAGE",
    "category": "Company Presentation",
    "industry": "Healthcare",
    "owner": "ZS",
    "ownerIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/zsIcon.png"
  }
]
const rcData = [
  {
    "name": "Tourism News and Management",
    "url": "https://experiences.cleverstory.io/world-holiday-edition",
    "desktopIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/world.png",
    "mobileIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/worldMob.png",
    "type": "RESOURCE_CENTER",
    "category": "Blog",
    "industry": "Public Service",
    "owner": "World",
    "ownerIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/worldIcon.png"
  },
  {
    "name": "Cloud Printing Solutions",
    "url": "https://experiences.cleverstory.io/toshiba",
    "desktopIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/toshiba.png",
    "mobileIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/toshibaMob.png",
    "type": "RESOURCE_CENTER",
    "category": "Product Presentation",
    "industry": "IT",
    "owner": "Toshiba",
    "ownerIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/toshibaIcon.png"
  },
  {
    "name": "Risk Management and Insurance",
    "url": "https://campaigns-baldwin.cleverstory.io/the-baldwin-group",
    "desktopIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/baldwin.png",
    "mobileIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/baldwinMob.png",
    "type": "RESOURCE_CENTER",
    "category": "Case Study Page",
    "industry": "Financial Services",
    "owner": "Baldwin",
    "ownerIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/baldwinIcon.png"
  },
  {
    "name": "S-Class Cars",
    "url": "https://experiences.cleverstory.io/s-class",
    "desktopIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/e2open.png",
    "mobileIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/e2openMob.png",
    "type": "RESOURCE_CENTER",
    "category": "Product Brochure",
    "industry": "Engineering",
    "owner": "E2 Open",
    "ownerIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/e2openIcon.png"
  },
  {
    "name": "Security Solutions",
    "url": "https://campaigns-genetec.cleverstory.io/genetec",
    "desktopIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/genetec.png",
    "mobileIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/genetecMob.png",
    "type": "RESOURCE_CENTER",
    "category": "Product Presentation",
    "industry": "Public Service",
    "owner": "Genetec",
    "ownerIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/genetecIcon.png"
  },
  {
    "name": "Digital Banks",
    "url": "https://campaigns-paymentology.cleverstory.io/paymentology-4d6irz",
    "desktopIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/paymentology.png",
    "mobileIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/paymentologyMob.png",
    "type": "RESOURCE_CENTER",
    "category": "Product Brochure",
    "industry": "Financial Services",
    "owner": "Paymentology",
    "ownerIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/paymentologyIcon.png"
  },
  {
    "name": "Internal Fraud Management",
    "url": "https://campaigns-linkurious.cleverstory.io/linkurious",
    "desktopIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/linkurious.png",
    "mobileIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/linkuriousMob.png",
    "type": "RESOURCE_CENTER",
    "category": "Case Study Page",
    "industry": "Financial Services",
    "owner": "Linkurious",
    "ownerIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/linkuriousIcon-1.png"
  },
  {
    "name": "News",
    "url": "https://experiences.cleverstory.io/tns-news",
    "desktopIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/tnsNew.png",
    "mobileIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/tnsNewMob.png",
    "type": "RESOURCE_CENTER",
    "category": "Blog",
    "industry": "Public Service",
    "owner": "TNS New",
    "ownerIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/tnsNewIcon.png"
  },
  {
    "name": "Cloud Management",
    "url": "https://campaigns-elitery.cleverstory.io/elitery",
    "desktopIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/elitery.png",
    "mobileIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/eliteryMob.png",
    "type": "RESOURCE_CENTER",
    "category": "Case Study Page",
    "industry": "IT",
    "owner": "Elitery",
    "ownerIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/eliteryIcon.png"
  }
]

const spData = [
  {
    "name": "Discover Wildlife",
    "url": "https://experiences.cleverstory.io/discover",
    "desktopIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/africanSafari.png",
    "mobileIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/africanSafariMob.png",
    "type": "SPATIAL",
    "category": "Website",
    "industry": "Hospitality",
    "owner": "African Safari",
    "ownerIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/africanSafariIcon.png"
  },
  {
    "name": "Diving Experience",
    "url": "https://experiences.cleverstory.io/diving",
    "desktopIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/deepdive.png",
    "mobileIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/deepdiveMob.png",
    "type": "SPATIAL",
    "category": "Website",
    "industry": "Hospitality",
    "owner": "Deep Dive",
    "ownerIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/deepdiveIcon.png",
  },
  {
    "name": "Astro Connect",
    "url": "https://experiences.cleverstory.io/astro-connect",
    "desktopIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/orbisync.png",
    "mobileIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/orbisyncMob.png",
    "type": "SPATIAL",
    "category": "Website",
    "industry": "IT",
    "owner": "Orbisync",
    "ownerIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/orbisyncIcon.png",
  },
  {
    "name": "Got Questions We've Got Answers",
    "url": "https://experiences.cleverstory.io/got-questions-we-ve-got-answers",
    "desktopIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/paperflite.png",
    "mobileIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/paperfliteMob.png",
    "type": "SPATIAL",
    "category": "Website",
    "industry": "Marketing",
    "owner": "Paperflite",
    "ownerIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/paperfliteIcon.png",
  },
  {
    "name": "Basic Coding",
    "url": "https://experiences.cleverstory.io/basic-coding",
    "desktopIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/codedu.png",
    "mobileIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/codeduMob.png",
    "type": "SPATIAL",
    "category": "Guidebook",
    "industry": "Education",
    "owner": "Codedu",
    "ownerIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/codeduIcon.png"
  },
  {
    "name": "Law Services",
    "url": "https://experiences.cleverstory.io/our-suite-of-legal-solutions",
    "desktopIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/lawfirm.png",
    "mobileIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/lawfirmMob.png",
    "type": "SPATIAL",
    "category": "Website",
    "industry": "Public Service",
    "owner": "Law Firm",
    "ownerIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/lawfirmIcon.png"
  },
  {
    "name": "Tourism",
    "url": "https://experiences.cleverstory.io/discover-your-adventure",
    "desktopIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/realmEscape.png",
    "mobileIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/realmEscapeMob.png",
    "type": "SPATIAL",
    "category": "Website",
    "industry": "Hospitality",
    "owner": "Realm Escape",
    "ownerIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/realmEscapeIcon.png",
  },
  {
    "name": "Food and Beverage Law",
    "url": "https://experiences.cleverstory.io/page-1-4num3p",
    "desktopIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/alstonAndBird.png",
    "mobileIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/alstonAndBirdMob.png",
    "type": "SPATIAL",
    "category": "Website",
    "industry": "Public Service",
    "owner": "Alston And Bird",
    "ownerIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/alstonAndBirdIcon.png",
  },
  {
    "name": "Sustainable Energy Management",
    "url": "https://experiences.cleverstory.io/an-alternative-energy-source",
    "desktopIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/energize.png",
    "mobileIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/energizeMob.png",
    "type": "SPATIAL",
    "category": "Website",
    "industry": "Public Service",
    "owner": "Energize",
    "ownerIcon": "/public/cleverstory/v2/showcase/v2/fallinlove-images/energizeIcon.png",
  }
]

export default function Carousel() {
  const interactiveRef = useRef(null);
  const landingRef = useRef(null);
  const resourceRef = useRef(null);
  const spatialRef = useRef(null);

  const onWheel = (ev, ref) => {
    const slider = ref.current;
    if (!slider) return;

    const isTouchpad = Math.abs(ev.deltaY) !== 0 || Math.abs(ev.deltaX) < 15;

    if (isTouchpad) {
      ev.stopPropagation();
      return;
    }

    if (ev.deltaX > 0) {
      slider.slickNext();
    } else if (ev.deltaX < 0) {
      slider.slickPrev();
    }
  };

  var settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 3,
    adaptiveHeight: true,
    variableWidth: true,
    prevArrow: <i class="cleverstory-drop-down" aria-label="Previous"></i>,
    nextArrow: <i class="cleverstory-drop-down" aria-label="Next"></i>,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          dots: false,
          draggable: true,
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          dots: false,
          draggable: true,
          slidesToShow: 1,
          slidesToScroll: 2,
          arrows: false,
        },
      },
      {
        breakpoint: 575,
        settings: {
          dots: false,
          draggable: true,
          slidesToShow: 1,
          slidesToScroll: 2,
          arrows: false,
        },
      },
    ],
  };

  const getOwnerId = (showcase) => {
    return;
  };

  const returnSmallCase = (value) => {
    var getOwnerId = value.owner.trim();
    getOwnerId = getOwnerId.replace(/\s/g, "");
    getOwnerId = getOwnerId.toLowerCase();
    return getOwnerId;
  };

  return (
    <>
      <div className={styles.contentWrapper}>

        <div className={styles.textSection}>
          <h2 className={styles.heading}>Wall of fame</h2>
          <h4 className={styles.subHeding}>A frame for every name</h4>
          <p className={cx(styles.paragraph)}>
            The time we kept pieces of the sky for ourselves - and framed them
            :)
          </p>
        </div>

        <div className={styles.container}>
          <div className={cx(styles.carousel, styles.interactiveContent)} onWheel={(ev) => onWheel(ev, interactiveRef)}>
            <h4 className={styles.smallHeading}>Interactive Content</h4>
            <Slider className={styles.wallofFrameCarousel} {...settings} ref={interactiveRef}>
              {icData.map((item, index) => (
                <div key={index}>
                  <div className={styles.template}>
                    <a href={item.url} target="_blank">
                      <IKImage
                        className={cx(styles.thumbnail, styles.desktop)}
                        path={item.desktopIcon}
                        transformation={[{
                          "width": "600"
                        }]}
                      />
                    </a>
                    <a href={item.url} target="_blank">
                      <IKImage
                        className={cx(styles.thumbnail, styles.mobile)}
                        path={item.mobileIcon}
                        transformation={[{
                          "width": "600"
                        }]}
                      />
                    </a>
                    <h5 className={styles.pageName}>{item.name}</h5>
                    <div className={styles.owner}>
                      <IKImage
                        path={item.ownerIcon}
                        className={cx(styles[item.owner.toLowerCase().replace(/\s+/g, '')])}
                        transformation={[{
                          "width": "600"
                        }]}
                      />
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>

          <div className={cx(styles.carousel, styles.landingPages)} onWheel={(ev) => onWheel(ev, landingRef)}>
            <h4 className={styles.smallHeading}>Landing Pages</h4>
            <Slider className={styles.wallofFrameCarousel} {...settings} ref={landingRef}>
              {lpData.map((item, index) => (
                <div key={index}>
                  <div className={styles.template}>
                    <a href={item.url} target="_blank">
                      <IKImage
                        className={cx(styles.thumbnail, styles.desktop)}
                        path={item.desktopIcon}
                        transformation={[{
                          "width": "600"
                        }]}
                      />
                    </a>
                    <a href={item.url} target="_blank">
                      <IKImage
                        className={cx(styles.thumbnail, styles.mobile)}
                        path={item.mobileIcon}
                        transformation={[{
                          "width": "600"
                        }]}
                      />
                    </a>
                    <h5 className={styles.pageName}>{item.name}</h5>
                    <div className={styles.owner}>
                      <IKImage
                        path={item.ownerIcon}
                        className={cx(styles[item.owner.toLowerCase().replace(/\s+/g, '')])}
                        transformation={[{
                          "width": "600"
                        }]}
                      />
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>

          <div className={cx(styles.carousel, styles.resourceCenters)} onWheel={(ev) => onWheel(ev, resourceRef)}>
            <h4 className={styles.smallHeading}>Resource Centers</h4>
            <Slider className={styles.wallofFrameCarousel} {...settings} ref={resourceRef}>
              {rcData.map((item, index) => (
                <div key={index}>
                  <div className={styles.template}>
                    <a href={item.url} target="_blank">
                      <IKImage
                        className={cx(styles.thumbnail, styles.desktop)}
                        path={item.desktopIcon}
                        transformation={[{
                          "width": "600"
                        }]}
                      />
                    </a>
                    <a href={item.url} target="_blank">
                      <IKImage
                        className={cx(styles.thumbnail, styles.mobile)}
                        path={item.mobileIcon}
                        transformation={[{
                          "width": "600"
                        }]}
                      />
                    </a>
                    <h5 className={styles.pageName}>{item.name}</h5>
                    <div className={styles.owner}>
                      <IKImage
                        path={item.ownerIcon}
                        className={cx(styles[item.owner.toLowerCase().replace(/\s+/g, '')])}
                        transformation={[{
                          "width": "600"
                        }]}
                      />
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>

          <div className={cx(styles.carousel, styles.spatial)} onWheel={(ev) => onWheel(ev, spatialRef)}>
            <h4 className={styles.smallHeading}>Spatial Experience</h4>
            <Slider className={styles.wallofFrameCarousel} {...settings} ref={spatialRef}>
              {spData.map((item, index) => (
                <div key={index}>
                  <div className={styles.template}>
                    <a href={item.url} target="_blank">
                      <IKImage
                        className={cx(styles.thumbnail, styles.desktop)}
                        path={item.desktopIcon}
                        transformation={[{
                          "width": "600"
                        }]}
                      />
                    </a>
                    <a href={item.url} target="_blank">
                      <IKImage
                        className={cx(styles.thumbnail, styles.mobile)}
                        path={item.mobileIcon}
                        transformation={[{
                          "width": "600"
                        }]}
                      />
                    </a>
                    <h5 className={styles.pageName}>{item.name}</h5>
                    <div className={styles.owner}>
                      <IKImage
                        path={item.ownerIcon}
                        className={cx(styles[item.owner.toLowerCase().replace(/\s+/g, '')])}
                        transformation={[{
                          "width": "600"
                        }]}
                      />
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </>
  );
}
